import "./FoodItem.css";
export default function ToggleControl({ checked, onToggle }) {
  return (
    <label className="toggle-control">
      <input
        type="checkbox"
        checked={checked}
        onChange={onToggle}
        className="toggle-input"
      />
      <span className="toggle-slider"></span>
    </label>
  );
}
